import React from 'react';

const CustomBotMessageHeader = ({ customBotName }) => {
    if (!customBotName) {
        return <></>;
    }

    return (
        <div className="flex items-center min-h-[25px]">
            <p className="font-body-bold text-body-bold-xs text-neutral-300 uppercase">
                {customBotName}
            </p>
        </div>
    );
};

export default CustomBotMessageHeader;
